import { isEmpty } from 'lodash'
import dayjs from '@/services/date'

/**
 * @obsolete Use checkCacheFreshness instead
 */
const isCacheFresh = ({
  cacheDuration,
  durationUnits,
  lastUpdated,
  forceRefresh = false,
  isDirty = false,
}) => {
  // If not being forced to refresh and it hasn't been longer than staleness threshold
  // return resource without API call
  return (
    !isEmpty(lastUpdated) &&
    dayjs(lastUpdated).isValid() &&
    !forceRefresh &&
    !isDirty &&
    dayjs().diff(lastUpdated, durationUnits) < cacheDuration
  )
}

export { isCacheFresh }
